var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2c1.63 0 3.147.496 4.414 1.336l1.2-1.2a.46.46 0 0 1 .786.325v3.08a.46.46 0 0 1-.46.459h-3.08a.46.46 0 0 1-.324-.786l.72-.72A6.355 6.355 0 0 0 10 3.6 6.387 6.387 0 0 0 3.6 10c0 3.545 2.855 6.4 6.4 6.4 3.545 0 6.4-2.855 6.4-6.4a.8.8 0 1 1 1.6 0c0 4.41-3.59 8-8 8s-8-3.59-8-8 3.59-8 8-8z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.0894f35b96bf4a8e6d82fdad51268479.svg";
export { ForwardRef as ReactComponent };